import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PrivateRoute from './common/private-route/private-route';
import Routes from './constants/routes';
import AsyncComponent from './routes/index';
import { domainManager } from './utils/domain-manager';
import MetaWrapper from './utils/meta-wrapper';

export default (
    <Switch>
        <Route
            exact
            component={() =>
                domainManager(
                    <AsyncComponent componentName='NewMaterialPage' meta={Routes.AUTHOR_DOMAIN_MATERIAL_PAGE.meta} />,
                    <Redirect exact from='/' to={Routes.HOME.path} />
                )
            }
            path={Routes.AUTHOR_DOMAIN_MATERIAL_PAGE.path}
        />
        <Route
            exact
            component={() =>
                domainManager(
                    <AsyncComponent componentName='Author' meta={Routes.AUTHOR_MAIN.meta} tab='Main' />,
                    <Redirect exact from='/' to={Routes.HOME.path} />
                )
            }
            path={Routes.ENTRY_POINT.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='Author' meta={Routes.USER_PROFILE.meta} tab='Main' />}
            path={Routes.USER_PROFILE.path}
        />
        <Route
            exact
            component={() => <AsyncComponent className='font-roboto-only' componentName='Jobs' />}
            path={Routes.JOBS.path}
        />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='ReferralsLanding' />}
            path={Routes.REFERRAL_INCENTIVE_LANDING.path}
        />
        <Route
            exact
            component={() => (
                <AsyncComponent componentName='SchoolLandingPage' meta={Routes.SCHOOL_LANDING_PAGES.meta} />
            )}
            path={Routes.SCHOOL_LANDING_PAGES.prefix}
        />
        <Route
            exact
            component={() => (
                <AsyncComponent componentName='SchoolLandingPage' meta={Routes.SCHOOL_LANDING_PAGES.meta} />
            )}
            path={Routes.SCHOOL_LANDING_PAGES.path}
        />
        <Route
            exact
            component={() => (
                <AsyncComponent
                    componentName='SwitchLandingComponent'
                    isSchoolLanding
                    meta={Routes.SCHOOL_LANDING_PAGES.meta}
                />
            )}
            path={Routes.SCHOOL_LANDING_PAGES.fullpath}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='ReferralsLandingForUnauthorized' />}
            path={Routes.REFERRAL_INCENTIVE_LANDING_FOR_UNAUTHORIZED.path}
        />
        <Route exact component={() => <AsyncComponent componentName='LMPHistory' />} path={Routes.LMP_HISTORY.path} />
        <Route exact component={() => <AsyncComponent componentName='OurTeam' />} path={Routes.OUR_TEAM.path} />
        <Route
            exact
            component={() => <AsyncComponent componentName='MobileAppLanding' />}
            path={Routes.MOBILE_APP_LANDING.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper
                    component={<AsyncComponent componentName='MentalHealthLanding' />}
                    meta={Routes.MENTAL_HEALTH_LANDING.meta}
                />
            )}
            path={Routes.MENTAL_HEALTH_LANDING.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper
                    component={<AsyncComponent componentName='MentalHealthKidsLanding' />}
                    meta={Routes.MENTAL_HEALTH_KIDS_LANDING.meta}
                />
            )}
            path={Routes.MENTAL_HEALTH_KIDS_LANDING.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='RussiaAttacksUkraineLanding' />}
            path={Routes.RUSSIA_ATTACKS_UKRAINE_LANDING.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='ClimateAction' />}
            path={Routes.CLIMATE_ACTION.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='DonateUkraine' />}
            path={Routes.DONATE_UKRAINE.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='Inclusion' />}
            path={Routes.INCLUSION_CAMPAIGN.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='BuilderPreview' />}
            path={Routes.BUILDER_PREVIEW.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='InteractiveMainLanding' />}
            path={Routes.INTERACTIVE_MAIN_LANDING.path}
        />
        <PrivateRoute
            exact
            component={() => (
                <MetaWrapper
                    component={<AsyncComponent componentName='CreateBlogpost' />}
                    meta={Routes.CREATE_BLOGPOST.meta}
                />
            )}
            path={Routes.CREATE_BLOGPOST.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper component={<AsyncComponent componentName='Home' />} meta={Routes.HOME.meta} />
            )}
            path={Routes.HOME.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='Blogpost' meta={Routes.BLOGPOST.meta} />}
            path={Routes.BLOGPOST.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper
                    component={<AsyncComponent componentName='FreeMaterialsLanding' />}
                    meta={Routes.FREE_MATERIALS_LANDING.meta}
                />
            )}
            path={Routes.FREE_MATERIALS_LANDING.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper component={<AsyncComponent componentName='Seller' />} meta={Routes.SELLER.meta} />
            )}
            path={Routes.SELLER.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper component={<AsyncComponent componentName='Seller' />} meta={Routes.SELLER.meta} />
            )}
            path={Routes.TEILEN.path}
        />
        <Route exact component={() => <AsyncComponent componentName='AutoLogin' />} path={Routes.AUTHORIZE.path} />
        <Route
            exact
            component={() => (
                <MetaWrapper component={<AsyncComponent componentName='Partners' />} meta={Routes.PARTNERS.meta} />
            )}
            path={Routes.PARTNERS.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='Author' meta={Routes.AUTHOR_MAIN.meta} tab='Main' />}
            path={Routes.AUTHOR_MAIN.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='Author' meta={Routes.USER_PROFILE.meta} tab='Main' />}
            path={Routes.USER_PROFILE.path}
        />
        <Route
            exact
            component={() => (
                <AsyncComponent componentName='Author' meta={Routes.USER_PROFILE_NO_SLUG.meta} tab='Main' />
            )}
            path={Routes.USER_PROFILE_NO_SLUG.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='SwitchLandingComponent' meta={Routes.LANDING.meta} />}
            path={Routes.LANDING.path}
        />
        <Route
            exact
            component={() => <AsyncComponent isStiftung componentName='Landing' meta={Routes.STIFTUNG_LANDING.meta} />}
            path={Routes.STIFTUNG_LANDING.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='KeywordLanding' meta={Routes.KEYWORD_LANDING.meta} />}
            path={Routes.KEYWORD_LANDING.path}
        />
        <Route
            exact
            component={() => <AsyncComponent isSale componentName='Landing' meta={Routes.SALE_LANDING.meta} />}
            path={Routes.SALE_LANDING.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='NewMaterialPage' meta={Routes.MATERIAL.meta} />}
            path={Routes.MATERIAL.path}
        />
        <Route
            exact
            component={() => (
                <AsyncComponent componentName='MaterialCardPreview' meta={Routes.MATERIAL_CARD_PREVIEW.meta} />
            )}
            path={Routes.MATERIAL_CARD_PREVIEW.path}
        />
        <Route exact component={() => <AsyncComponent componentName='ImpactPage' />} path={Routes.IMPACT_PAGE.path} />

        <Route
            exact
            component={() => <AsyncComponent componentName='GdprJobs' meta={Routes.GDPR_JOBS.meta} />}
            path={Routes.GDPR_JOBS.defaultPath}
        />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='MaterialFeedback' meta={Routes.MATERIAL_FEEDBACK.meta} />}
            path={Routes.MATERIAL_FEEDBACK.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper component={<AsyncComponent componentName='Cart' />} meta={Routes.WARENKORB.meta} />
            )}
            path={Routes.WARENKORB.path}
        />
        <Route
            exact
            component={() => (
                <AsyncComponent
                    componentName='Payment'
                    loadedReducers={[
                        {
                            key: 'payment',
                            path: 'payment/new'
                        }
                    ]}
                />
            )}
            path={Routes.PAYMENT.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='ThankYouPage' />}
            path={Routes.THANK_YOU_PAGE.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='ThankYouPageInvoice' />}
            path={Routes.THANK_YOU_PAGE_INVOICE.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper
                    component={<AsyncComponent componentName='SearchResult' />}
                    meta={Routes.SEARCH_RESULT.meta}
                />
            )}
            path={Routes.SEARCH_RESULT.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper
                    component={<AsyncComponent componentName='SellerSteps' step={0} />}
                    meta={Routes.STEPS_NAME.meta}
                />
            )}
            path={Routes.STEPS_NAME.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper
                    component={<AsyncComponent componentName='SellerSteps' step={1} />}
                    meta={Routes.STEPS_HOCHLADEN.meta}
                />
            )}
            path={Routes.STEPS_HOCHLADEN.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper component={<AsyncComponent componentName='SignIn' />} meta={Routes.LOGIN.meta} />
            )}
            path={Routes.LOGIN.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper component={<AsyncComponent componentName='SignUp' />} meta={Routes.SIGN_UP.meta} />
            )}
            path={Routes.SIGN_UP.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper
                    component={<AsyncComponent componentName='SignUpConfirm' />}
                    meta={Routes.SIGN_UP_CONFIRM.meta}
                />
            )}
            path={Routes.SIGN_UP_CONFIRM.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper
                    component={<AsyncComponent componentName='ChangeEmailConfirm' />}
                    meta={Routes.CHANGE_EMAIL_CONFIRM.meta}
                />
            )}
            path={Routes.CHANGE_EMAIL_CONFIRM.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper component={<AsyncComponent componentName='HelpCenter' />} meta={Routes.HELP_CENTER.meta} />
            )}
            path={Routes.HELP_CENTER.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper component={<AsyncComponent componentName='Impressum' />} meta={Routes.IMPRESSUM.meta} />
            )}
            path={Routes.IMPRESSUM.path}
        />
        <Route
            exact
            component={() => <MetaWrapper component={<AsyncComponent componentName='Agb' />} meta={Routes.AGB.meta} />}
            path={Routes.AGB.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper
                    component={<AsyncComponent componentName='ForgotPassword' />}
                    meta={Routes.FORGOT_PASSWORD.meta}
                />
            )}
            path={Routes.FORGOT_PASSWORD.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper component={<AsyncComponent componentName='Favorites' />} meta={Routes.FAVORITES.meta} />
            )}
            path={Routes.FAVORITES.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper
                    component={<AsyncComponent componentName='Unsubscribe' />}
                    meta={Routes.UNSUBSCRIBE.meta}
                />
            )}
            path={Routes.UNSUBSCRIBE.path}
        />
        <Route
            exact
            component={() => <MetaWrapper component={<AsyncComponent componentName='Api' />} meta={Routes.API.meta} />}
            path={Routes.API.path}
        />
        <Route
            exact
            component={() => (
                <AsyncComponent componentName='MailingUnsubscribe' meta={Routes.MAILING_UNSUBSCRIBE.meta} />
            )}
            path={Routes.MAILING_UNSUBSCRIBE.path}
        />
        <Route
            exact
            component={() => (
                <AsyncComponent isNew componentName='MailingUnsubscribe' meta={Routes.UNSUBSCRIBE_BY_LINK.meta} />
            )}
            path={Routes.UNSUBSCRIBE_BY_LINK.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='UnsubscribeAuthor' />}
            path={Routes.AUTHOR_UNSUBSCRIBE.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='PasswordRecovery' />}
            path={Routes.PASSWORD_RECOVERY.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='FinishRegistration' />}
            path={Routes.FINISH_REGISTRATION.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='FreeDownload' />}
            path={Routes.FREE_DOWNLOAD.path}
        />
        <Route exact component={() => <AsyncComponent componentName='LoginAs' />} path={Routes.LOGIN_AS.path} />
        <Route
            exact
            component={() => (
                <MetaWrapper
                    component={<AsyncComponent componentName='HomeSchooling' />}
                    meta={Routes.HOME_SCHOOLING.meta}
                />
            )}
            path={Routes.HOME_SCHOOLING.path}
        />
        <Route
            exact
            component={() => (
                <MetaWrapper component={<AsyncComponent componentName='Podcasts' />} meta={Routes.PODCASTS.meta} />
            )}
            path={Routes.PODCASTS.path}
        />
        <Route exact component={() => <AsyncComponent componentName='Magazine' />} path={Routes.MAGAZINE.path} />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='AuthorRedirect' />}
            path={Routes.AUTHOR_REDIRECT.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='AbandonedCartRedirect' />}
            path={Routes.ABANDONED_CART_REDIRECT.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='MicrosoftRedirectURI' />}
            path={Routes.MICROSOFT_REDIRECT_URI.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='FillPersonalizationRedirect' />}
            path={Routes.FILL_PERSONALIZATION_REDIRECT.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='AgroNordwest' />}
            path={Routes.AGRO_NORDWEST.path}
        />
        <Route exact component={() => <AsyncComponent componentName='AiTools' />} path={Routes.AI_TOOLS.path} />
        <Route
            component={() => <AsyncComponent componentName='AiToolDocument' />}
            path={Routes.AI_TOOL_DOCUMENT.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='AiToolsMyDocuments' />}
            path={Routes.AI_TOOLS_DOCUMENTS.path}
        />
        <Route exact component={() => <AsyncComponent componentName='AiToolsFaq' />} path={Routes.AI_TOOLS_FAQ.path} />
        <Route exact component={() => <AsyncComponent componentName='AiToolPage' />} path={Routes.AI_TOOL_PAGE.path} />

        <Route exact component={() => <AsyncComponent componentName='Nps' />} path={Routes.NPS.path} />
        <Route
            exact
            component={() => <AsyncComponent componentName='schoolAccount' />}
            path={Routes.SCHOOL_ACCOUNT.path}
        />
        <Route
            exact
            component={() => <AsyncComponent componentName='SchoolCreate' />}
            path={Routes.SCHOOL_CREATE.path}
        />
        <Route
            component={() => <AsyncComponent componentName='NewInteractive' />}
            path={Routes.NEW_INTERACTIVE_MAIN.path}
        />
        <PrivateRoute exact component={() => <AsyncComponent componentName='Fonts' />} path={Routes.FONTS.path} />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='MySchool' />}
            path={Routes.MY_SCHOOL.path}
        />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='SchoolWishlist' />}
            path={Routes.SCHOOL_WISHLIST.path}
        />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='PreferenceCenter' />}
            path={Routes.CABINET_PREFERENCE_CENTER.path}
        />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='DownloadsList' />}
            path={Routes.BOUGHT_MATERIALS.path}
        />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='InvoicesAndTaxes' />}
            path={Routes.INVOICES_AND_TAXES.path}
        />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='BankDetails' />}
            path={Routes.CABINET_BANK_DETAILS.path}
        />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='ChangePassword' />}
            path={Routes.CABINET_CHANGE_PASSWORD.path}
        />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='ChangeEmail' />}
            path={Routes.CABINET_CHANGE_EMAIL.path}
        />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='ChangeCountry' />}
            path={Routes.CHANGE_COUNTRY.path}
        />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='InvoiceInfo' />}
            path={Routes.CABINET_INVOICE_INFO.path}
        />
        <PrivateRoute
            xexact
            component={() => <AsyncComponent componentName='Recommendations' />}
            path={Routes.SEASONAL_MATERIALS_LANDING.path}
        />
        <PrivateRoute
            exact
            component={() => (
                <AsyncComponent
                    componentName='MyUploads'
                    loadedReducers={[
                        {
                            key: 'materialUpload',
                            path: 'cabinet/material-wizard'
                        },
                        {
                            key: 'bundle',
                            path: 'cabinet/bundle-wizard'
                        }
                    ]}
                />
            )}
            path={Routes.CABINET_SALES.path}
        />
        <PrivateRoute exact component={() => <AsyncComponent componentName='Vouchers' />} path={Routes.VOUCHERS.path} />
        <PrivateRoute exact component={() => <AsyncComponent componentName='Charts' />} path={Routes.CHARTS.path} />
        <PrivateRoute
            exact
            component={() => <AsyncComponent componentName='CreditNotes' />}
            path={Routes.CREDIT_NOTES.path}
        />
        <PrivateRoute exact component={() => <AsyncComponent componentName='Credits' />} path={Routes.CREDITS.path} />
        <PrivateRoute exact component={() => <AsyncComponent componentName='MySales' />} path={Routes.MY_SALES.path} />
        <PrivateRoute
            component={() => (
                <AsyncComponent
                    firstUpload
                    componentName='Wizard'
                    loadedReducers={[
                        {
                            key: 'materialUpload',
                            path: 'cabinet/material-wizard'
                        }
                    ]}
                />
            )}
            path={Routes.CABINET_UPLOAD.path}
        />
        <Route component={() => <AsyncComponent componentName='NotFound' />} />
    </Switch>
);
